import { Component, OnDestroy, OnInit } from '@angular/core';

import { useDispatcher } from '../../../store.decorator';
import {
    CategoryAction,
    CategoryDisplayAs,
    EventCentreHookService,
} from '../core';

import { TranslationKeyMap } from './event-centre-dialog.i18n';
import { EventCentreDialogService } from './event-centre-dialog.service';
import { defaultState } from './event-centre-dialog.state';
import { filterItems } from './state/filter-items.action';
import { toggleSearch } from './state/toggle-search.action';

@Component({
    selector: 'cmps-event-centre-dialog',
    templateUrl: './event-centre-dialog.component.html',
    host: {
        class: 'cmps-event-centre-dialog',
    },
})
export class EventCentreDialogComponent implements OnInit, OnDestroy {
    /** @private */
    _i18n = TranslationKeyMap;

    /** @private */
    _CategoryDisplayAs = CategoryDisplayAs;

    constructor(
        /** @private */ readonly _service: EventCentreDialogService,
        private readonly _actionHookService: EventCentreHookService,
    ) {}

    ngOnInit(): void {
        useDispatcher(this._service, toggleSearch({ open: false }));
        useDispatcher(
            this._service,
            filterItems({
                opts: defaultState().filterOpts,
            }),
        );
    }

    ngOnDestroy(): void {}

    /** @private */
    _onCategoryActionClick(action: CategoryAction): void {
        this._actionHookService.categoryActionInvoked(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
        );

        this._actionHookService.categoryActionInvoked2(
            this._service.state.category,
            action,
            this._service.state.filteredItems,
            this._service,
        );
    }
}
